export default "__VITE_ASSET__B998csTP__"